import React from "react";

import { ButtonGroupRenderer } from "src/features/forms/components/ButtonGroupRenderer";
import { CheckboxGroupRenderer } from "src/features/forms/components/CheckboxGroupRenderer";
import { CheckboxRenderer } from "src/features/forms/components/CheckboxRenderer";
import { CountrySelectRenderer } from "src/features/forms/components/CountrySelectRenderer";
import { CountySelectRenderer } from "src/features/forms/components/CountySelectRenderer";
import { InputRenderer } from "src/features/forms/components/InputRenderer";
import { MeasuredButtonGroupRenderer } from "src/features/forms/components/MeasuredButtonGroupRenderer";
import { RadioGroupRenderer } from "src/features/forms/components/RadioGroupRenderer";
import { RemoteSelectRenderer } from "src/features/forms/components/RemoteSelectRenderer";
import { SelectRenderer } from "src/features/forms/components/SelectRenderer";
import { SliderRenderer } from "src/features/forms/components/SlideRenderer";
import { SwitchRenderer } from "src/features/forms/components/SwitchRenderer";
import { TextAreaRenderer } from "src/features/forms/components/TextAreaRenderer";
import { UnknownInput } from "src/features/forms/types";

import { RemoteMultiSelectRenderer } from "./RemoteMultiSelectRenderer";

export const UnknownInputRenderer: React.FunctionComponent<
	UnknownInput
> = input => {
	if (input.type === "input") {
		return <InputRenderer {...input.props} />;
	}
	if (input.type === "textarea") {
		return <TextAreaRenderer {...input.props} />;
	}
	if (input.type === "remote-select") {
		return <RemoteSelectRenderer {...input.props} />;
	}
	if (input.type === "remote-multi-select") {
		return <RemoteMultiSelectRenderer {...input.props} />;
	}
	if (input.type === "select") {
		return <SelectRenderer {...input.props} />;
	}
	if (input.type === "country") {
		return <CountrySelectRenderer {...input.props} />;
	}
	if (input.type === "county") {
		return <CountySelectRenderer {...input.props} />;
	}
	if (input.type === "slider") {
		return <SliderRenderer {...input.props} />;
	}
	if (input.type === "checkbox") {
		return <CheckboxRenderer {...input.props} />;
	}
	if (input.type === "switch") {
		return <SwitchRenderer {...input.props} />;
	}
	if (input.type === "button-group") {
		return <ButtonGroupRenderer {...input.props} />;
	}
	if (input.type === "measured-button-group") {
		return <MeasuredButtonGroupRenderer {...input.props} />;
	}
	if (input.type === "radio-group") {
		return <RadioGroupRenderer {...input.props} />;
	}
	if (input.type === "checkbox-group") {
		return <CheckboxGroupRenderer {...input.props} />;
	}
	throw new Error();
};
